import { BankAccountType as ApiBankAccountType } from 'src/api/generated/touring/types';
import { mapAddress } from '../common';
import { BankAccountType } from './types';

export const mapBankAccountType = (
  apiBankAccount: ApiBankAccountType
): BankAccountType => ({
  id: apiBankAccount.id,
  status: apiBankAccount.status,
  accountHolderName: apiBankAccount.accountHolderName,
  accountHolderAddress: mapAddress(apiBankAccount.accountHolderAddress),
  currency: apiBankAccount.currency,
  bankName: apiBankAccount.bankName,
  bankAddress: mapAddress(apiBankAccount.bankAddress),
  accountNumber: apiBankAccount.accountNumber,
  bicSwift: apiBankAccount.bicSwift,
  iban: apiBankAccount.iban,
  routingNumber: apiBankAccount.routingNumber,
  notes: apiBankAccount.notes,
  creditorNumber: apiBankAccount.creditorNumber,
  canBeApproved: apiBankAccount.canBeApproved,
  deletionReason: apiBankAccount.deletionReason,
});
